import { FastApiAxiosInstance } from 'common/service/axiosInstances';

//资产交易service
const artTransaction = {
  getBuyAssetOrder: (params: { price: string; assetId: string; frontUrl: string }): ExtendAxioResponse<any> => {
    return FastApiAxiosInstance.post('/api/v1/order/asset/create', params);
  },
};
export default artTransaction;
